import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "truncate" }
const _hoisted_2 = {
  "data-day-change-message": "",
  class: "text-sm text-gray-700"
}
const _hoisted_3 = { class: "mt-3 space-y-2 text-sm text-gray-700" }
const _hoisted_4 = { "data-day-change-keep": "" }
const _hoisted_5 = { "data-day-change-move": "" }
const _hoisted_6 = { class: "border-b border-gray-200 w-full mb-8" }
const _hoisted_7 = {
  class: "-mb-px flex",
  "aria-label": "Tabs"
}
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "h-8 w-8 flex-shrink-0"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-gray-500 ml-1"
}
const _hoisted_13 = { class: "italic" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "flex space-x-4 flex-1" }
const _hoisted_16 = { class: "text-left text-gray-700" }
const _hoisted_17 = { class: "text-sm font-medium leading-none" }
const _hoisted_18 = { class: "text-sm text-gray-500" }
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_23 = { class: "max-w-[1040px]" }
const _hoisted_24 = { class: "w-full lg:w-3/5" }
const _hoisted_25 = { class: "border-gray-200" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "h-12 w-12 rounded-md bg-gray-100 flex items-center justify-center"
}
const _hoisted_29 = { class: "text-lg text-gray-500" }
const _hoisted_30 = { class: "ml-4 flex flex-1 sm:ml-6" }
const _hoisted_31 = { class: "w-full flex-grow basis-0 mr-8 flex items-center" }
const _hoisted_32 = { class: "w-full h-full" }
const _hoisted_33 = { class: "w-full flex flex-col md:flex-row justify-start md:justify-between md:items-center" }
const _hoisted_34 = { class: "inline-flex items-center" }
const _hoisted_35 = ["disabled", "onChange"]
const _hoisted_36 = ["selected"]
const _hoisted_37 = { class: "ml-2 w-20 text-sm font-medium text-gray-900 text-right font-mono flex justify-between" }
const _hoisted_38 = {
  key: 0,
  class: "border-l border-l-gray-300 space-y-1 mt-3 md:mt-1"
}
const _hoisted_39 = {
  key: 1,
  class: "w-56 mt-3"
}
const _hoisted_40 = {
  key: 0,
  class: "italic mb-4"
}
const _hoisted_41 = { class: "mt-3 flex justify-between" }
const _hoisted_42 = { class: "flex gap-2" }
const _hoisted_43 = { class: "mt-6 lg:mt-0 flex flex-col lg:flex-grow basis-1/3" }
const _hoisted_44 = { class: "bg-gray-100 border border-gray-200 rounded-lg pl-6 pr-1 py-2 space-y-2" }
const _hoisted_45 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_46 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_47 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_48 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_49 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_50 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_51 = {
  key: 0,
  class: "grid grid-cols-3 gap-4"
}
const _hoisted_52 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_53 = {
  key: 1,
  class: "grid grid-cols-3 gap-4"
}
const _hoisted_54 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_55 = {
  key: 2,
  class: "grid grid-cols-2 gap-4"
}
const _hoisted_56 = { class: "text-sm text-gray-900 col-span-1 mt-0 text-right font-mono" }
const _hoisted_57 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_58 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_59 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_60 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_61 = { class: "text-sm font-medium text-gray-700 flex items-center" }
const _hoisted_62 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono" }
const _hoisted_63 = { class: "col-span-3 grid grid-cols-3" }
const _hoisted_64 = { class: "text-xs text-gray-700 col-span-2" }
const _hoisted_65 = { class: "text-xs text-gray-700 mt-0 text-right font-mono" }
const _hoisted_66 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_67 = { class: "text-sm text-gray-900 col-span-2 mt-0 text-right font-mono font-bold" }
const _hoisted_68 = { class: "py-2 grid grid-cols-3 gap-4" }
const _hoisted_69 = { class: "text-xs text-gray-500 mt-0 text-right font-mono" }
const _hoisted_70 = { class: "pb-2 grid grid-cols-3 gap-4" }
const _hoisted_71 = { class: "text-xs text-gray-500 mt-0 text-right font-mono" }
const _hoisted_72 = {
  key: 0,
  class: "mt-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center"
}
const _hoisted_73 = { class: "text-sm font-medium text-gray-500 whitespace-nowrap flex items-center" }
const _hoisted_74 = { class: "text-gray-400 hover:text-blue-500 ml-1" }
const _hoisted_75 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_76 = { class: "flex-grow" }
const _hoisted_77 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_78 = { class: "ml-4 flex-shrink-0" }
const _hoisted_79 = { class: "mt-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_80 = {
  key: 0,
  class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
}
const _hoisted_81 = {
  key: 1,
  class: "text-gray-500 cursor-not-allowed"
}
const _hoisted_82 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4" }
const _hoisted_83 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_84 = {
  key: 1,
  class: "text-gray-500 cursor-not-allowed"
}
const _hoisted_85 = {
  key: 2,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_86 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_87 = { class: "mt-8 max-w-[1040px]" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_90 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_91 = { class: "flex-grow" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 1,
  class: "italic"
}
const _hoisted_94 = { class: "ml-4 flex-shrink-0" }
const _hoisted_95 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_96 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_97 = { class: "flex-grow" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = {
  key: 1,
  class: "italic"
}
const _hoisted_100 = { class: "ml-4 flex-shrink-0" }
const _hoisted_101 = {
  key: 0,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_102 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm space-y-1" }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_105 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_106 = { class: "capitalize" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = ["href"]
const _hoisted_110 = { key: 4 }
const _hoisted_111 = {
  key: 5,
  class: "text-red-400"
}
const _hoisted_112 = { key: 6 }
const _hoisted_113 = {
  key: 7,
  class: "text-red-600"
}
const _hoisted_114 = {
  key: 8,
  class: "pt-1"
}
const _hoisted_115 = {
  key: 9,
  class: "pt-1"
}
const _hoisted_116 = {
  key: 1,
  class: "md:flex md:w-full md:divide-x md:divide-gray-200"
}
const _hoisted_117 = { class: "max-w-[21rem] sm:w-[21rem] flex-none md:pr-8" }
const _hoisted_118 = { class: "flex items-center" }
const _hoisted_119 = { class: "mt-2 grid grid-cols-7 text-sm" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "mt-12 md:mt-0 md:pl-8" }
const _hoisted_122 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = ["checked"]
const _hoisted_125 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_126 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_127 = {
  key: 0,
  class: "italic"
}
const _hoisted_128 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_129 = { class: "mt-4" }
const _hoisted_130 = { key: 2 }
const _hoisted_131 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_132 = { class: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_133 = {
  key: 0,
  class: "w-full space-y-4"
}
const _hoisted_134 = ["onClick"]
const _hoisted_135 = { class: "flex flex-1" }
const _hoisted_136 = { class: "flex flex-col" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { class: "flex items-center h-6 gap-1.5" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = ["onClick"]
const _hoisted_142 = { class: "flex flex-col" }
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_145 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_146 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_147 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_148 = { class: "mt-1 sm:col-span-2 sm:mt-0" }
const _hoisted_149 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_150 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-center" }
const _hoisted_151 = {
  key: 0,
  class: "mt-2 self-end flex gap-3"
}
const _hoisted_152 = {
  key: 1,
  class: "flex items-center w-full"
}
const _hoisted_153 = { class: "flex-grow" }
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { key: 0 }
const _hoisted_156 = { key: 1 }
const _hoisted_157 = {
  key: 1,
  class: "italic"
}
const _hoisted_158 = { class: "ml-4 flex-shrink-0" }
const _hoisted_159 = { class: "mt-8 max-w-[1040px]" }
const _hoisted_160 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_161 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_162 = { class: "flex-grow italic" }
const _hoisted_163 = { class: "ml-4 flex-shrink-0" }
const _hoisted_164 = { key: 0 }
const _hoisted_165 = {
  key: 0,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_166 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_167 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4" }
const _hoisted_168 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_169 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_170 = {
  key: 1,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_171 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_172 = {
  key: 2,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_173 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_174 = {
  key: 3,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_175 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_176 = {
  key: 4,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_177 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" }
const _hoisted_178 = { key: 0 }
const _hoisted_179 = {
  key: 1,
  class: "italic mb-2"
}
const _hoisted_180 = {
  key: 3,
  class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4"
}
const _hoisted_181 = { class: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex items-center flex-wrap gap-2" }
const _hoisted_182 = { key: 0 }
const _hoisted_183 = ["href"]
const _hoisted_184 = { class: "py-2 sm:grid sm:grid-cols-3 sm:gap-4 flex items-center" }
const _hoisted_185 = { class: "mt-1 flex items-center text-sm text-gray-900 sm:col-span-2 sm:mt-0 max-w-sm" }
const _hoisted_186 = { class: "flex-grow" }
const _hoisted_187 = { key: 0 }
const _hoisted_188 = { key: 0 }
const _hoisted_189 = { key: 1 }
const _hoisted_190 = {
  key: 1,
  class: "italic"
}
const _hoisted_191 = { class: "ml-4 flex-shrink-0" }
const _hoisted_192 = {
  key: 1,
  class: "flex gap-2 flex-wrap"
}
const _hoisted_193 = ["onClick"]
const _hoisted_194 = { key: 0 }
const _hoisted_195 = { key: 1 }
const _hoisted_196 = { class: "w-full flex gap-2 mt-2" }
const _hoisted_197 = { class: "flex mt-4 space-x-3 items-start" }
const _hoisted_198 = { class: "max-w-[1040px]" }
const _hoisted_199 = {
  key: 0,
  class: "h-20"
}
const _hoisted_200 = {
  role: "list",
  class: "-mb-8"
}
const _hoisted_201 = { class: "relative pb-8" }
const _hoisted_202 = {
  key: 0,
  class: "absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200",
  "aria-hidden": "true"
}
const _hoisted_203 = { class: "relative flex items-start gap-x-3 px-1" }
const _hoisted_204 = { class: "flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white" }
const _hoisted_205 = { class: "min-w-0 flex-1 flex justify-between py-1.5" }
const _hoisted_206 = ["onClick"]
const _hoisted_207 = { class: "font-medium text-gray-900" }
const _hoisted_208 = { class: "font-medium text-gray-900" }
const _hoisted_209 = { class: "font-medium text-gray-900" }
const _hoisted_210 = {
  key: 2,
  class: "w-full mt-2"
}
const _hoisted_211 = { key: 0 }
const _hoisted_212 = {
  key: 1,
  class: "text-sm text-gray-500 max-w-2xl"
}
const _hoisted_213 = {
  key: 0,
  class: "block mt-1 italic"
}
const _hoisted_214 = { class: "flex items-center justify-between w-[15.5rem]" }
const _hoisted_215 = { class: "whitespace-nowrap text-sm text-gray-500 ml-2" }
const _hoisted_216 = { class: "max-w-[1040px]" }
const _hoisted_217 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_218 = { class: "flex justify-end" }
const _hoisted_219 = { class: "truncate" }
const _hoisted_220 = { class: "break-words" }
const _hoisted_221 = { key: 0 }
const _hoisted_222 = {
  key: 1,
  class: "italic"
}
const _hoisted_223 = { class: "flex justify-end" }
const _hoisted_224 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_225 = ["href"]

import { MenuItem } from '@headlessui/vue'
import {
  ArrowDownTrayIcon,
  ArrowRightOnRectangleIcon,
  ArrowUpRightIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  BanknotesIcon,
  BuildingLibraryIcon,
  CheckIcon,
  ClipboardDocumentIcon,
  ClipboardDocumentListIcon,
  CursorArrowRaysIcon,
  EnvelopeIcon,
  InformationCircleIcon,
  PencilIcon,
  PlusIcon,
  ReceiptRefundIcon,
  ShoppingBagIcon,
  SparklesIcon,
  UserIcon,
  WindowIcon,
  XMarkIcon
} from '@heroicons/vue/20/solid'
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'
import _ from 'lodash'
import { computed, nextTick, onMounted, ref } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import RefundModal from '@/components/neue/RefundModal.vue'
import ResellerBanner from '@/components/ResellerBanner.vue'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { useToast } from '@/composables/useToast'
import { hasMembershipProgram } from '@/config/membershipTierView'
import { dateObjectToServerDay, serverDayToDateObject } from '@/helpers/dates'
import { haversineMiles } from '@/helpers/geo'
import { getScrollParent } from '@/helpers/getScrollParent'
import { collectedOutsideStripe, isPlacedOrder, paymentReasonLabel } from '@/helpers/orderPayment'
import { fullObject } from '@/helpers/partialObjects'
import { maxRefundCentsFor } from '@/helpers/refund'
import australiaStates from '@/models/australiaStates'
import canadianStates from '@/models/canadianStates'
import unitedKingdomStates from '@/models/unitedKingdomStates'
import usaStates from '@/models/usaStates'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'
import DiscountCodeInput from '@/view/activity/DiscountCodeInput.vue'

const CARD = 'rounded-xl border border-gray-200 bg-white p-6 shadow-sm'

const discountIncludes = 'checkout,cart,cart.applied_discount_codes'


export default {
  __name: 'OrderDetailNeue',
  setup(__props) {

const vuexStore = useStore()
const canReadOrders = computed(() => privilegeService.canAccessResourceAction('orders', null, 'read'))
const canUpdateOrders = computed(() => privilegeService.canAccessResourceAction('orders', null, 'update'))
const canCreateReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'create'))
const canUpdateMembershipTiers = computed(
  () =>
    hasMembershipProgram(vuexStore.state.loggedInUser) &&
    privilegeService.canAccessResourceAction('sell', null, 'update')
)
const canUpdateStores = computed(() => privilegeService.canAccessResourceAction('sell', null, 'update'))
const route = useRoute()
const router = useRouter()
const { showToast } = useToast()

const TABS = [
  { id: 'overview', name: 'Overview' },
  { id: 'activity', name: 'Activity' },
  { id: 'reports', name: 'Reports' }
]
const { activeTab, sections } = useRouteTabs(
  TABS,
  computed(() => '/order/' + route.params.id)
)

const loading = ref(true)
const activityLoading = ref(true)
const discountInput = ref(null)
const allStates = computed(() =>
  (
    ({ USA: usaStates, AUS: australiaStates, CAN: canadianStates, GBR: unitedKingdomStates })[
      vuexStore.getters.country
    ] ?? []
  ).map(x => ({
    name: x.label,
    value: x.value
  }))
)
const bottle = computed(() => fullObject(mapRelationship({ type: 'bottle', id: route.params.id })))
const uberDelivery = computed(() => bottle.value?.attributes?.uber_delivery)
// 'cancelled_by_you' | 'cancelled' | 'failed' | 'active' | null
const uberDeliveryState = computed(() => {
  const delivery = uberDelivery.value
  if (!delivery) return null
  if (delivery.merchant_cancelled_at) return 'cancelled_by_you'
  if (delivery.status === 'failed' || delivery.is_active === false) {
    return ['canceled', 'returned'].includes(delivery.status) ? 'cancelled' : 'failed'
  }
  return 'active'
})
const detail = computed(() => mapRelationship(bottle.value?.relationships.bottle_detail?.data))
const activities = computed(() => {
  const pureActivities = mapRelationships(detail.value?.relationships?.activities?.data ?? [])
  const carts = mapRelationships(detail.value?.relationships?.carts?.data ?? [])
  return [...pureActivities, ...carts].sort(
    (a, b) => new Date(b.attributes.created_at) - new Date(a.attributes.created_at)
  )
})
const checkout = computed(() => mapRelationship(bottle.value?.relationships.checkout?.data))
const pair = computed(() => mapRelationship(bottle.value?.relationships.conversation_user_pair?.data))
// const customer = computed(() => mapRelationship(pair.value?.relationships.customer.data))
const tier = computed(() => mapRelationship(bottle.value?.relationships.membership_tier?.data))
const tiers = computed(() => mapType('membership_tier'))
// const distributionList = computed(() => mapRelationship(bottle.value?.relationships.distribution_list.data))
const store = computed(() => mapRelationship(bottle.value?.relationships.store?.data))
const drop = computed(() => mapRelationship(bottle.value?.relationships.bottle_cycle?.data))
const payment = computed(() => mapRelationship(bottle.value?.relationships.bottle_payment?.data))
// BOT-1546: the Stripe invoice for an order placed on an invoice-only store.
const bottleInvoice = computed(() => mapRelationship(bottle.value?.relationships.bottle_invoice?.data))
const invoiceDueDate = computed(() => {
  const due = bottleInvoice.value?.attributes?.due_date
  return due ? dateFmt(new Date(due)) : ''
})
const invoiceStatusLabel = computed(() => {
  const status = bottleInvoice.value?.attributes?.status
  if (status === 'open') return 'Unpaid'
  if (status === 'paid') return bottleInvoice.value.attributes.paid_out_of_band ? 'Paid outside Stripe' : 'Paid'
  if (status === 'void') return 'Voided'
  return status
})
const maxRefundCents = computed(() => maxRefundCentsFor(payment.value, checkout.value))
const intent = computed(() => mapRelationship(bottle.value?.relationships.stripe_payment_intent?.data))
const paymentMethod = computed(() => mapRelationship(intent.value?.relationships.stripe_payment_method?.data))
const cart = computed(() => mapRelationship(bottle.value?.relationships.cart?.data))
const appliedDiscountCodes = computed(() =>
  mapRelationships(cart.value?.relationships?.applied_discount_codes?.data ?? [])
)
const items = computed(() =>
  _.sortBy(
    mapRelationships(cart.value?.relationships?.cart_items?.data ?? []),
    x => x.attributes.fulfillment_group_date ?? selectedSlot.value?.attributes.arrives_beginning_estimate_date
  )
)
const itemCount = computed(() => items.value.reduce((acc, x) => acc + x.attributes.quantity, 0))
const selectedAddress = computed(() => mapRelationship(bottle.value?.relationships.delivery_address?.data))
const addresses = computed(() =>
  mapRelationships(bottle.value?.relationships.possible_delivery_addresses?.data).sort(
    (a, b) => (b.id === selectedAddress.value?.id) - (a.id === selectedAddress.value?.id)
  )
)
const selectedMethod = computed(() => mapRelationship(bottle.value?.relationships.fulfillment_method?.data))
const possibleMethods = computed(() => mapRelationships(bottle.value?.relationships.possible_fulfillment_methods?.data))
const selectedSlot = computed(() => mapRelationship(bottle.value?.relationships.fulfillment_slot?.data))
const autofillOptions = computed(() => mapRelationships(bottle.value?.relationships.autofill_options?.data))
const possibleTips = computed(() => mapRelationships(bottle.value?.relationships.possible_tip_amounts?.data))
const tip = computed(() => mapRelationship(bottle.value?.relationships.tip_amount?.data))
const reports = computed(() =>
  mapType('data_download') // newest first
    ?.filter(x => x.relationships.bottle.data?.id == route.params.id)
    ?.sort((a, b) => new Date(b.attributes.created_at) - new Date(a.attributes.created_at))
)

const product = item => mapRelationship(item?.relationships?.product?.data)
const variants = product => mapRelationships(product?.relationships?.variants?.data ?? [])
const image = product => mapRelationships(product?.relationships?.attachments?.data ?? [])[0]?.attributes?.secure_url
const slots = day =>
  mapType('fulfillment_slot')?.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day)) ?? []
const activityIcon = activity =>
  ({
    LinkClickActivity: CursorArrowRaysIcon,
    ConfirmationActivity: CheckIcon,
    ProceedToCheckoutActivity: WindowIcon,
    SkipActivity: ArrowUturnRightIcon,
    UnskipActivity: ArrowUturnLeftIcon,
    PaidActivity: BanknotesIcon,
    RefundActivity: ReceiptRefundIcon,
    CancelledActivity: XMarkIcon,
    NewContactActivity: PlusIcon,
    AnswerActivity: ClipboardDocumentListIcon,
    LoginActivity: ArrowRightOnRectangleIcon,
    AutomationActivity: SparklesIcon,
    IssuedCreditActivity: BuildingLibraryIcon
  })[activity.attributes.type] ?? InformationCircleIcon

const activityColor = activity =>
  ({
    LinkClickActivity: 'text-gray-900',
    ConfirmationActivity: 'text-green-600',
    ProceedToCheckoutActivity: 'text-gray-900',
    PaidActivity: 'text-green-600',
    RefundActivity: 'text-green-600',
    CancelledActivity: 'text-red-600',
    NewContactActivity: 'text-gray-900',
    AnswerActivity: 'text-gray-900',
    LoginActivity: 'text-gray-900',
    AutomationActivity: 'text-blue-600',
    IssuedCreditActivity: 'text-green-600'
  })[activity.attributes.type] ?? 'text-blue-600'

const selectedDay = ref(new Date())
const selectingSlot = ref(false)
const selectingAddress = ref(false)
const editingAddress = ref(false)
const dayChange = ref(null)
const weekdayFormat = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' }).format
const dayLabel = slot => (slot ? weekdayFormat(serverDayToDateObject(slot.date)) : '')
const keepLabel = computed(() => `Keep ${dayLabel(dayChange.value?.current)}`)
const moveLabel = computed(() => `Move to ${dayLabel(dayChange.value?.suggested)}`)
const dayChangeWhy = computed(() => {
  if (!dayChange.value) return ''
  const { current, reason } = dayChange.value
  return reason === 'outside_area'
    ? `This address is outside the delivery area for ${dayLabel(current)}.`
    : `${dayLabel(current)} is closed for new orders.`
})
const keepOutcome = computed(() =>
  dayChange.value
    ? `The order and its items stay under Activity for ${dayLabel(dayChange.value.current)}, in the Orders and Products tabs. Nothing moves to ${dayLabel(dayChange.value.suggested)}.`
    : ''
)
const moveOutcome = computed(() => {
  if (!dayChange.value) return ''
  const { current, suggested } = dayChange.value
  const method =
    suggested.fulfillment_method_name !== current.fulfillment_method_name
      ? ` (${suggested.fulfillment_method_name})`
      : ''
  return `The order and its items show under Activity for ${dayLabel(suggested)}${method}, in the Orders and Products tabs, and disappear from ${dayLabel(current)}.`
})
const offMenuItems = computed(() => dayChange.value?.off_menu_item_names ?? [])
const moveWarning = computed(() => {
  if (!dayChange.value) return ''
  const names = offMenuItems.value
  if (!names.length) return "Its items move as they are and will be counted in that day's Products tab."
  const many = names.length > 1
  return `${names.length} ${many ? 'items' : 'item'} in this order ${many ? 'are' : 'is'} not on the menu for ${dayLabel(dayChange.value.suggested)}: ${names.join(', ')}. ${many ? 'They' : 'It'} will still move with the order and be counted in that day's Products tab.`
})
const draftAddress = ref({ address1: '', address2: '', city: '', state: '', zip: '', notes: '' })
const openVariantTray = ref(null)
const refundModal = ref(false)
const recharging = ref(false)
const rechargeError = ref('')
const bookingCourier = ref(false)
const cancellingCourier = ref(false)
const quotingCourier = ref(false)
const uberActionError = ref('')
const reportsModal = ref(false)
const addModal = ref({ open: false })
const copyFlash = ref(false)
const openCarts = ref(new Set())
const cartRefs = ref({})
const taxesExpanded = ref(false)
const autofillOption = ref(null)
const selectingTip = ref(false)
const customTipAmount = ref('')

const itemVariants = item => {
  const grouped = _.groupBy(item.attributes.variant_options_selection, 'variant_name')
  return Object.keys(grouped)
    .map(key => `${key}: ${grouped[key].map(x => x.variant_option_name).join(', ')}`)
    .join(', ')
}

const dateFmt = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long'
}).format

const slotArrives = slot => {
  if (!slot?.attributes?.arrives_beginning_estimate || !slot?.attributes?.arrives_ending_estimate) return ''
  const start = new Date(slot.attributes.arrives_beginning_estimate)
  const end = new Date(slot.attributes.arrives_ending_estimate)
  if (Number.isNaN(+start) || Number.isNaN(+end)) return ''

  const timeFmt = new Intl.DateTimeFormat('en-US', {
    timeStyle: 'short'
  }).format
  const fullFmt = new Intl.DateTimeFormat('en-US', {
    dateStyle: 'long',
    timeStyle: 'short'
  }).format

  if (dateFmt(start) === dateFmt(end)) {
    if (timeFmt(start) === timeFmt(end)) {
      return `${dateFmt(start)}, ${timeFmt(start)}`
    } else {
      return `${dateFmt(start)}, ${timeFmt(start)} - ${timeFmt(end)}`
    }
  } else {
    return fullFmt(start) + ' - ' + fullFmt(end)
  }
}
const slotMethod = slot => mapRelationship(slot?.relationships?.fulfillment_method?.data)

const methodPossible = method => possibleMethods.value.some(x => x.id == method.id)

const plusDays = (date, days) => {
  const d = new Date(date.getTime())
  d.setDate(date.getDate() + days)
  return d
}
const plusMonths = (date, months) => {
  const d = new Date(date.getTime())
  d.setMonth(date.getMonth() + months)
  return d
}
const days = computed(() => {
  const startOfMonth = new Date(selectedDay.value.getFullYear(), selectedDay.value.getMonth(), 1)
  const endOfMonth = new Date(selectedDay.value.getFullYear(), selectedDay.value.getMonth() + 1, 0)

  const start = plusDays(startOfMonth, -startOfMonth.getDay())
  const end = plusDays(endOfMonth, 6 - endOfMonth.getDay())

  const days = []
  for (let i = 0; plusDays(start, i) <= end; i++) {
    days.push(plusDays(start, i))
  }
  return days
})
const dayFormat = new Intl.DateTimeFormat('en-US', {
  day: 'numeric'
}).format
const monthDayFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric'
}).format
const monthFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  year: 'numeric'
}).format
const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
  timeStyle: 'short'
}).format
const activityFormat = new Intl.DateTimeFormat('en-US', {
  month: 'numeric',
  day: 'numeric',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
}).format
const isSelectedMonth = date =>
  selectedDay.value.getMonth() === date.getMonth() && selectedDay.value.getFullYear() === date.getFullYear()
const isSelectedDay = date =>
  selectedDay.value.getDate() === date.getDate() &&
  selectedDay.value.getMonth() === date.getMonth() &&
  selectedDay.value.getFullYear() === date.getFullYear()
const isCurrentDay = date =>
  new Date().getDate() === date.getDate() &&
  new Date().getMonth() === date.getMonth() &&
  new Date().getFullYear() === date.getFullYear()

const sendableCart = computed(() => {
  const newItems = []
  for (const item of items.value) {
    const { id: _id, category_product_store_pair_id, quantity, fulfillment_group_date } = item.attributes
    newItems.push({
      _id,
      category_product_store_pair_id,
      quantity,
      fulfillment_group_date,
      cart_item_variant_options_attributes: item.attributes.variant_options_selection.map(
        ({ variant_id, variant_option_id, quantity }) => ({ variant_id, variant_option_id, quantity })
      )
    })
  }
  return {
    cart: {
      cart_items_attributes: newItems
    }
  }
})

const addProducts = () => {
  addModal.value = {
    open: true,
    tab: 'existing',
    custom: { name: '', price: '', quantity: 1 },
    searchQuery: '',
    searchResults: [],
    selectedProducts: []
  }
}

const callWithCartErrorPopup = async (method, endpoint, body, options) => {
  try {
    const response = await api.call(method, endpoint, body, options)
    const errors = response?.data?.data?.attributes?.validations?.all_errors ?? []
    if (errors.length) {
      const lowered = errors.map(e => e.charAt(0).toLowerCase() + e.slice(1)).join('; ')
      showToast(`The order was updated, but ${lowered}`, { type: 'info' })
    }
    return response
  } catch (error) {
    const message =
      error?.response?.data?.errors?.[0] ||
      error?.response?.data?.error ||
      "Couldn't update the cart. Please try again."
    showToast(message, { type: 'error' })
    throw error
  }
}

const saveAddModal = () => {
  const cart = sendableCart.value
  if (addModal.value.tab === 'existing') {
    for (const product of addModal.value.selectedProducts) {
      cart.cart.cart_items_attributes.push({
        product_id: product.id,
        quantity: 1
      })
    }
  } else {
    cart.cart.cart_items_attributes.push({
      product_attributes: {
        is_active: false,
        requires_fulfillment: false,
        product_name: addModal.value.custom.name,
        default_price_cents: Math.round(addModal.value.custom.price * 100)
      },
      quantity: addModal.value.custom.quantity
    })
  }
  const includes = [
    'checkout',
    'cart.cart_items',
    'cart.cart_items.product',
    'cart.cart_items.product.attachments',
    'cart.cart_items.cart_item_variant_options'
  ]
  callWithCartErrorPopup('POST', `bottles/${route.params.id}/carts?included=${includes.join(',')}`, cart)
  addModal.value.open = false
}

const setCartQuantity = (item, quantity) => {
  const cart = sendableCart.value
  cart.cart.cart_items_attributes.find(x => x._id == item.id).quantity = quantity === 'Remove' ? 0 : quantity
  const includes = [
    'checkout',
    'cart.cart_items',
    'cart.cart_items.product',
    'cart.cart_items.product.attachments',
    'cart.cart_items.cart_item_variant_options'
  ]
  callWithCartErrorPopup('POST', `bottles/${route.params.id}/carts?included=${includes.join(',')}`, cart)
}

const setOption = (item, variant, option) => {
  const cart = sendableCart.value
  const cartItem = cart.cart.cart_items_attributes.find(x => x._id == item.id)
  let variantSelection = cartItem.cart_item_variant_options_attributes
  if (variant.attributes.quantity_option === 'choose_one') {
    variantSelection = variantSelection.filter(x => x.variant_id != variant.id)
    variantSelection.push({ variant_id: variant.id, variant_option_id: option.id })
  } else {
    // choose_many
    const alreadySelected = variantSelection.some(x => x.variant_id == variant.id && x.variant_option_id == option.id)
    if (alreadySelected) {
      // remove
      variantSelection = variantSelection.filter(x => !(x.variant_id == variant.id && x.variant_option_id == option.id))
    } else {
      variantSelection.push({ variant_id: variant.id, variant_option_id: option.id })
    }
  }
  cartItem.cart_item_variant_options_attributes = variantSelection
  const includes = [
    'checkout',
    'cart.cart_items',
    'cart.cart_items.product',
    'cart.cart_items.product.attachments',
    'cart.cart_items.cart_item_variant_options'
  ]
  callWithCartErrorPopup('POST', `bottles/${route.params.id}/carts?included=${includes.join(',')}`, cart)
}

const setVariantQuantity = (item, variant, option, quantity) => {
  const cart = sendableCart.value
  const cartItem = cart.cart.cart_items_attributes.find(x => x._id == item.id)
  let variantSelection = cartItem.cart_item_variant_options_attributes
  const existing = variantSelection.find(x => x.variant_id == variant.id && x.variant_option_id == option.id)
  if (existing) {
    if (quantity) {
      // update quantity
      existing.quantity = quantity
    } else {
      // new quantity is zero, remove
      variantSelection = variantSelection.filter(x => !(x.variant_id == variant.id && x.variant_option_id == option.id))
    }
  } else {
    if (quantity) {
      variantSelection.push({ variant_id: variant.id, variant_option_id: option.id, quantity })
    }
  }
  cartItem.cart_item_variant_options_attributes = variantSelection
  const includes = [
    'checkout',
    'cart.cart_items',
    'cart.cart_items.product',
    'cart.cart_items.product.attachments',
    'cart.cart_items.cart_item_variant_options'
  ]
  callWithCartErrorPopup('POST', `bottles/${route.params.id}/carts?included=${includes.join(',')}`, cart)
}

const setFulfillment = (item, day) => {
  const cart = sendableCart.value
  const cartItem = cart.cart.cart_items_attributes.find(x => x._id == item.id)
  cartItem.fulfillment_group_date = day
  const includes = [
    'checkout',
    'cart.cart_items',
    'cart.cart_items.product',
    'cart.cart_items.product.attachments',
    'cart.cart_items.cart_item_variant_options'
  ]
  callWithCartErrorPopup('POST', `bottles/${route.params.id}/carts?included=${includes.join(',')}`, cart)
}

const uberDirectMoveWarnings = method => {
  const warnings = []

  if (!selectedAddress.value) {
    warnings.push('This order has no delivery address, so the courier cannot be booked.')
  }

  const pickupAddress = mapRelationship(method.relationships?.delivery_address?.data)
  const pickupLat = pickupAddress?.attributes.latitude
  const pickupLng = pickupAddress?.attributes.longitude
  const dropoffLat = selectedAddress.value?.attributes.latitude
  const dropoffLng = selectedAddress.value?.attributes.longitude
  const radius = method.attributes.uber_direct_radius_miles
  const hasCoords = [pickupLat, pickupLng, dropoffLat, dropoffLng, radius].every(x => typeof x === 'number')
  if (hasCoords) {
    const miles = haversineMiles(pickupLat, pickupLng, dropoffLat, dropoffLng)
    if (miles > radius) {
      warnings.push(
        `The delivery address is about ${Math.round(miles)} miles from the pickup address, outside the ${radius} mile radius Uber allows, so the courier will not be booked.`
      )
    }
  }

  if (uberDeliveryState.value !== 'active') {
    warnings.push(
      "The courier fee was not part of this order's payment. Booking the courier will charge it to the customer's card on file."
    )
  }

  return warnings
}

const uberDirectQuoteWarnings = (quote, isPaid) => {
  if (!quote || ['quote_unavailable', 'quote_failed'].includes(quote.error_code)) {
    return ['Courier fee could not be quoted right now.']
  }

  const warnings = []

  if (quote.total) {
    let line = `Courier fee: ${quote.total.format}`
    if (quote.spread?.cents > 0) {
      line += ` (Uber ${quote.uber_fee?.format} + ${quote.spread.format} platform fee)`
    }
    if (quote.customer_pays && !isPaid) {
      line += ' The customer pays it at checkout.'
    } else if (!quote.customer_pays) {
      line += ' You absorb it from your payout.'
    }
    warnings.push(line)
  }

  if (['outside_radius', 'address_undeliverable'].includes(quote.error_code)) {
    warnings.push("Uber will not deliver to this address from this method's pickup address.")
  }

  return warnings
}

const getUberDirectQuote = async slot => {
  quotingCourier.value = true
  try {
    const response = await api.call(
      'GET',
      `bottles/${route.params.id}/uber_direct_quotes?fulfillment_slot_id=${slot.id}`,
      {},
      { save: false }
    )
    return response.data
  } catch (error) {
    return null
  } finally {
    quotingCourier.value = false
  }
}

const setSlot = async slot => {
  const method = slotMethod(slot)
  const isPaid = bottle.value?.attributes?.payment_status === 'paid'

  if (method?.attributes.type === 'UberDirectFulfillmentMethod') {
    const quote = await getUberDirectQuote(slot)
    const warnings = [...uberDirectQuoteWarnings(quote, isPaid), ...(isPaid ? uberDirectMoveWarnings(method) : [])]
    if (warnings.length) {
      const confirmed = confirm(`Move this order to ${method.attributes.name}?\n\n${warnings.join('\n\n')}`)
      if (!confirmed) return
    }
  }

  callWithCartErrorPopup('PUT', `bottles/${route.params.id}?included=checkout`, {
    bottle: { fulfillment_slot_id: slot.id }
  })
  selectingSlot.value = false
}

const setTier = id => {
  callWithCartErrorPopup('PUT', `bottles/${route.params.id}?included=checkout,cart,cart.cart_items`, {
    bottle: { membership_tier_id: id }
  })
}

const applyDiscountCode = async code => {
  try {
    await api.call('POST', `bottles/${route.params.id}/discount_codes?included=${discountIncludes}`, { code })
    discountInput.value?.clear()
  } catch (error) {
    const message = error?.response?.data?.errors?.[0] || 'This code is invalid'
    discountInput.value?.showError(message)
  }
}

const removeDiscountCode = async appliedId => {
  try {
    await api.call(
      'DELETE',
      `bottles/${route.params.id}/applied_discount_codes/${appliedId}?included=${discountIncludes}`,
      {},
      { delete: false }
    )
  } catch (error) {
    showToast(error?.response?.data?.errors?.[0] || "Couldn't remove the code. Please try again.", { type: 'error' })
  }
}

const closeAddressEditor = () => {
  selectingAddress.value = false
  editingAddress.value = false
}

const saveAddressOnOrder = async bottleAttributes => {
  closeAddressEditor()
  try {
    await callWithCartErrorPopup(
      'PUT',
      `bottles/${route.params.id}?included=delivery_address,possible_delivery_addresses,checkout`,
      { bottle: bottleAttributes, keep_fulfillment_slot: true }
    )
  } catch {
    return
  }
  await offerDayChange()
}

const offerDayChange = async () => {
  try {
    const response = await api.call('GET', `bottles/${route.params.id}/fulfillment_slot_fits`, {}, { receive: false })
    if (response.data.suggests_other_day) dayChange.value = response.data
  } catch {
    dayChange.value = null
  }
}

const keepChosenDay = () => {
  dayChange.value = null
}

const slotInStore = id => mapType('fulfillment_slot')?.find(slot => slot.id === id)

const loadSlotOn = async (id, date) => {
  if (slotInStore(id)) return slotInStore(id)
  try {
    await api.call(
      'GET',
      `fulfillment_slots?date_from=${date}&date_to=${date}&included=fulfillment_method,fulfillment_method.delivery_address`
    )
  } catch {
    return null
  }
  return slotInStore(id)
}

const moveToSuggestedDay = async () => {
  const { id, date } = dayChange.value.suggested
  dayChange.value = null
  const slot = await loadSlotOn(id, date)
  if (slot) return setSlot(slot)
  return callWithCartErrorPopup(
    'PUT',
    `bottles/${route.params.id}?included=fulfillment_slot,fulfillment_method,checkout`,
    {
      bottle: { fulfillment_slot_id: id }
    }
  )
}

const setAddress = address => saveAddressOnOrder({ delivery_address_id: address.id })

const saveAddress = () => {
  if (draftAddress.value.id) {
    callWithCartErrorPopup(
      'PUT',
      `conversation_user_pairs/${pair.value.id}/delivery_addresses/${draftAddress.value.id}`,
      {
        delivery_address: draftAddress.value
      }
    )
    closeAddressEditor()
  } else {
    saveAddressOnOrder({ delivery_address_attributes: draftAddress.value })
  }
}

const addAddress = () => {
  draftAddress.value = {}
  editingAddress.value = true
}

const editAddress = address => {
  draftAddress.value = { id: address.id, ...address.attributes }
  editingAddress.value = true
}

const deleteAddress = address => {
  api.call('DELETE', `conversation_user_pairs/${pair.value.id}/delivery_addresses/${address.id}`)
}

const setTax = enabled => {
  api.call('PUT', `bottles/${route.params.id}?included=checkout`, {
    bottle: {
      calculate_tax_on_custom_invoice: enabled
    }
  })
}

const setTip = tip => {
  api.call('PUT', `bottles/${route.params.id}?included=checkout`, {
    bottle: {
      tip_amount_id: tip.id
    }
  })
  selectingTip.value = false
  customTipAmount.value = ''
}

const setCustomTip = () => {
  api.call('PUT', `bottles/${route.params.id}?included=tip_amount,checkout`, {
    bottle: {
      tip_amount_attributes: {
        type: 'CustomTipAmount',
        tip_amount_cents: Math.round(customTipAmount.value * 100)
      }
    }
  })
  selectingTip.value = false
  customTipAmount.value = ''
}

const refund = amountCents => {
  api.call('POST', `bottles/${route.params.id}/refunds`, {
    refund: {
      amount: amountCents
    }
  })
  refundModal.value = false
}

// BOT-1546: Stripe emails the open invoice again and the customer is texted the link.
const resendingInvoice = ref(false)
const resendInvoice = async () => {
  resendingInvoice.value = true
  try {
    await api.call('POST', `bottles/${route.params.id}/invoice_sends?included=bottle_invoice,bottle_payment,checkout`)
    showToast('Invoice sent to the customer again.', { type: 'info' })
  } catch (error) {
    showToast(error?.response?.data?.errors?.[0] || "Couldn't resend the invoice. Please try again.", { type: 'error' })
  } finally {
    resendingInvoice.value = false
  }
}

const markAsPaid = () =>
  api.call('POST', `bottles/${route.params.id}/pay?included=bottle_invoice,bottle_payment,checkout`)

const rechargeOrder = async () => {
  recharging.value = true
  rechargeError.value = ''
  try {
    await api.call('POST', `bottles/${route.params.id}/recharges`)
  } catch (e) {
    rechargeError.value = e.response?.data?.error || 'Failed to re-charge. Please try again.'
  } finally {
    recharging.value = false
  }
}

const formatCentsAsDollars = cents => `$${(cents / 100).toFixed(2)}`

const reloadBottleAfterUberAction = () => api.call('GET', `bottles/${route.params.id}?included=checkout`)

const bookCourier = async () => {
  bookingCourier.value = true
  uberActionError.value = ''
  try {
    await api.call('POST', 'uber_deliveries', { bottle_id: route.params.id })
    await reloadBottleAfterUberAction()
  } catch (e) {
    uberActionError.value = e.response?.data?.errors?.[0] || 'Could not book the courier. Please try again.'
  } finally {
    bookingCourier.value = false
  }
}

const cancelCourier = async () => {
  if (!confirm('Cancel this courier?')) return
  cancellingCourier.value = true
  uberActionError.value = ''
  try {
    await api.call('POST', `uber_deliveries/${uberDelivery.value.id}/cancel`)
    await reloadBottleAfterUberAction()
  } catch (e) {
    uberActionError.value = e.response?.data?.errors?.[0] || 'Could not cancel the courier. Please try again.'
  } finally {
    cancellingCourier.value = false
  }
}

// BOT-1764: unmarking an invoice reissues it; the reply carries the new invoice.
const markAsUnpaid = () =>
  api.call('POST', `bottles/${route.params.id}/unpay?included=bottle_invoice,bottle_payment,checkout`)

const cancelOrder = () =>
  api.call('PUT', `bottles/${route.params.id}`, { bottle: { cancellation_status: 'cancelled' } })

const uncancelOrder = () => api.call('PUT', `bottles/${route.params.id}`, { bottle: { cancellation_status: 'active' } })

const skip = () => api.call('POST', `bottles/${route.params.id}/skips`)

const unskip = () => api.call('POST', `bottles/${route.params.id}/unskips`)

const copyLink = () => {
  navigator.clipboard.writeText(bottle.value?.attributes.link)
  copyFlash.value = true
  setTimeout(() => {
    copyFlash.value = false
  }, 3000)
}

const sendToCustomer = () => {
  router.push({
    path: '/messages/' + pair.value.id,
    query: { message: "Here's a link to the order: " + bottle.value.attributes.link }
  })
}

const toggleCart = async activity => {
  const oldTop = cartRefs.value[activity.id].getBoundingClientRect().top

  if (openCarts.value.has(activity.id)) {
    openCarts.value.delete(activity.id)
  } else {
    openCarts.value.add(activity.id)
  }

  await nextTick()
  const newTop = cartRefs.value[activity.id].getBoundingClientRect().top
  getScrollParent(cartRefs.value[activity.id]).scrollBy(0, newTop - oldTop)
}

const rollback = cart =>
  api.call(
    'POST',
    `bottles/${route.params.id}/rollback?cart_id=${cart.id}&included=${[
      'bottle_detail',
      'bottle_detail.carts',
      'bottle_detail.carts.cart_items.cart_item_variant_options',
      'bottle_detail.carts.cart_items.product'
    ].join(',')}`
  )

const autofill = () => {
  const type = autofillOption.value.attributes.type
  if (type === 'package') {
    api.call(
      'POST',
      `bottles/${route.params.id}/autofills?autofill_type=package&package_id=${autofillOption.value.attributes.package_id}`
    )
  } else {
    api.call('POST', `bottles/${route.params.id}/autofills?autofill_type=${type}`)
  }
}

const getSlots = () => {
  const from = dateObjectToServerDay(days.value.at(0))
  const to = dateObjectToServerDay(days.value.at(-1))
  api.call(
    'GET',
    `fulfillment_slots?date_from=${from}&date_to=${to}&included=fulfillment_method,fulfillment_method.delivery_address`
  )
}

const load = id => {
  loading.value = true
  activityLoading.value = true
  // BOT-1745: one request shaped for this page, carrying the order, its cart,
  // payment, fulfillment and activity tab, instead of two general bottle
  // requests with long include lists.
  api.call('GET', `orders/${id}`).then(() => {
    loading.value = false
    activityLoading.value = false
    if (selectedSlot.value) selectedDay.value = serverDayToDateObject(selectedSlot.value.attributes.fulfillment_date)
    getSlots()
  })
  api.call('GET', 'membership_tiers?included=none')
  api.call('GET', `bottles/${id}/data_downloads`)
}

onMounted(() => load(route.params.id))

onBeforeRouteUpdate((to, from) => {
  if (to.params.id !== from.params.id) load(to.params.id)
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_NewReportModal = _resolveComponent("NewReportModal")
  const _component_VariantRow = _resolveComponent("VariantRow")
  const _component_DescriptionListInput = _resolveComponent("DescriptionListInput")
  const _component_Payment = _resolveComponent("Payment")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: 
          bottle.value
            ? (_unref(isPlacedOrder)(bottle.value?.attributes) ? 'Order' : 'Cart') + ' ' + bottle.value?.attributes.display_id
            : 'Order ...'
        ,
        "save-status": true,
        actions: 
          [
            canUpdateOrders.value && { name: 'Copy link', icon: _unref(ClipboardDocumentIcon), action: copyLink },
            bottle.value?.attributes.link &&
              canUpdateOrders.value && {
                name: 'Open order as customer',
                icon: _unref(ArrowUpRightIcon),
                action: () => _ctx.window.open(bottle.value?.attributes.link, '_blank')
              },
            bottle.value?.attributes.actions.skip &&
              canUpdateOrders.value && { name: 'Skip', icon: _unref(ArrowUturnRightIcon), action: skip },
            bottle.value?.attributes.actions.unskip &&
              canUpdateOrders.value && {
                name: 'Unskip',
                icon: _unref(ArrowUturnLeftIcon),
                action: unskip
              },
            bottle.value?.attributes.actions.refund &&
              canUpdateOrders.value && {
                name: 'Refund',
                icon: _unref(ReceiptRefundIcon),
                action: () => {
                  refundModal.value = true
                }
              },
            bottle.value?.attributes.actions.cancel_order &&
              canUpdateOrders.value && {
                name: 'Cancel',
                icon: _unref(XMarkIcon),
                action: cancelOrder
              },
            bottle.value?.attributes.actions.un_cancel_order &&
              canUpdateOrders.value && {
                name: 'Uncancel',
                icon: _unref(CheckIcon),
                action: uncancelOrder
              },
            {
              name: 'Download',
              icon: _unref(ArrowDownTrayIcon),
              action: () => {
                reportsModal.value = true
              }
            },
            { name: 'Draft message', icon: _unref(EnvelopeIcon), action: sendToCustomer }
          ].filter(Boolean)
        ,
        sections: _unref(sections)
      }, {
        titleRight: _withCtx(() => [
          (!loading.value && pair.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: '/profile/' + pair.value.id,
                class: "ml-3 inline-flex min-w-0 items-center gap-1 text-sm font-medium tracking-tight text-gray-500 hover:text-gray-700 hover:underline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UserIcon), {
                    class: "h-4 w-4 shrink-0",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(pair.value.attributes.display_name), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        right: _withCtx(() => [
          (canUpdateOrders.value)
            ? (_openBlock(), _createBlock(_component_NeueButton, {
                key: 0,
                type: "secondary",
                class: _normalizeClass(["hidden sm:inline-flex ml-3", copyFlash.value && '!bg-green-500 !text-white']),
                onClick: copyLink
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ClipboardDocumentIcon), {
                    class: "-ml-1 mr-2 h-5 w-5",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Cop" + _toDisplayString(copyFlash.value ? 'ied' : 'y') + " link ", 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["text", "actions", "sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(RefundModal, {
        "is-open": refundModal.value,
        "max-refund-cents": maxRefundCents.value,
        onClose: _cache[0] || (_cache[0] = $event => (refundModal.value = false)),
        onSubmit: refund
      }, null, 8, ["is-open", "max-refund-cents"]),
      _createVNode(_component_TheModal, {
        "is-open": !!dayChange.value,
        "modal-title": "Change fulfillment day?",
        onCloseModal: keepChosenDay
      }, {
        main: _withCtx(() => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(dayChangeWhy.value), 1),
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(keepLabel.value) + ":", 1),
              _createTextVNode(" " + _toDisplayString(keepOutcome.value), 1)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(moveLabel.value) + ":", 1),
              _createTextVNode(" " + _toDisplayString(moveOutcome.value) + " ", 1),
              _createElementVNode("span", {
                "data-day-change-warning": "",
                class: _normalizeClass(offMenuItems.value.length ? 'font-medium text-red-600' : '')
              }, _toDisplayString(moveWarning.value), 3)
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "primary",
            class: "mr-3",
            onClick: keepChosenDay
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(keepLabel.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: moveToSuggestedDay
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(moveLabel.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_TheModal, {
        "is-open": addModal.value.open,
        "modal-title": "Add products",
        onCloseModal: _cache[10] || (_cache[10] = $event => (addModal.value.open = false))
      }, {
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("nav", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass([
                  addModal.value.tab === 'existing'
                    ? 'border-brand-500 text-brand-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'w-1/2 border-b-2 py-4 px-1 text-center text-sm font-medium'
                ]),
                onClick: _cache[1] || (_cache[1] = $event => (addModal.value.tab = 'existing'))
              }, " Search for a product ", 2),
              _createElementVNode("button", {
                class: _normalizeClass([
                  addModal.value.tab === 'custom'
                    ? 'border-brand-500 text-brand-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'w-1/2 border-b-2 py-4 px-1 text-center text-sm font-medium'
                ]),
                onClick: _cache[2] || (_cache[2] = $event => (addModal.value.tab = 'custom'))
              }, " Custom line item ", 2)
            ])
          ]),
          (addModal.value.tab === 'existing')
            ? (_openBlock(), _createBlock(_component_InlineSearchSelect, {
                key: 0,
                "helper-text": {
              noResult: 'No results found',
              noneSelected: 'Select items',
              typingPrompt: 'Chicken Parmesan'
            },
                "search-endpoint": "products/search",
                "search-request": { query: addModal.value.searchQuery },
                onOnSearch: _cache[4] || (_cache[4] = x => (addModal.value.searchQuery = x)),
                onOnResults: _cache[5] || (_cache[5] = x => (addModal.value.searchResults = x))
              }, {
                searchResults: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.searchResults, (item) => {
                    return (_openBlock(), _createBlock(_unref(MenuItem), {
                      key: item.id,
                      class: "z-10"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass([addModal.value.selectedProducts.some(x => x.id == item.id) ? 'text-gray-300' : 'text-gray-700', "group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors inline-flex gap-2"]),
                          disabled: addModal.value.selectedProducts.some(x => x.id == item.id),
                          onClick: _withModifiers($event => (addModal.value.selectedProducts.push(item)), ["prevent"])
                        }, [
                          (image(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("img", {
                                  class: "w-full h-full object-center object-cover rounded select-none",
                                  src: image(item)
                                }, null, 8, _hoisted_10)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.attributes.product_name), 1),
                            (item.attributes.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " — " + _toDisplayString(item.attributes.description), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_8)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_unref(MenuItem), { class: "z-10" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors text-gray-700",
                        onClick: _cache[3] || (_cache[3] = _withModifiers($event => (addModal.value.selectedProducts.push(_ctx.item)), ["prevent"]))
                      }, [
                        _createElementVNode("span", _hoisted_13, "Custom cart item called \"" + _toDisplayString(addModal.value.searchQuery) + "\"", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                selectedItems: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.selectedProducts, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "group py-2 mt-2 px-2 duration-150 transition-colors hover:bg-gray-100"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_unref(CheckIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" }),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(item.attributes.product_name), 1),
                              _createElementVNode("p", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(item.attributes.description), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("button", {
                            onClick: _withModifiers($event => (
                        addModal.value.selectedProducts = addModal.value.selectedProducts.filter(x => x.id !== item.id)
                      ), ["prevent"])
                          }, [
                            _createVNode(_unref(XMarkIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" })
                          ], 8, _hoisted_20)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["search-request"]))
            : _createCommentVNode("", true),
          (addModal.value.tab === 'custom')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_FormSection, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormElement, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputField, {
                          modelValue: addModal.value.custom.name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((addModal.value.custom.name) = $event)),
                          name: "Name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FormElement, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputField, {
                          modelValue: addModal.value.custom.price,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((addModal.value.custom.price) = $event)),
                          name: "Price",
                          prefix: "$",
                          class: "w-1/3"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FormElement, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectInput, {
                          modelValue: addModal.value.custom.quantity,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((addModal.value.custom.quantity) = $event)),
                          name: "Quantity",
                          class: "w-1/3",
                          options: Array.from({ length: 200 }, (_, x) => ({ name: x + 1, value: x + 1 }))
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[9] || (_cache[9] = $event => (addModal.value.open = false))
          }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_NeueButton, {
            type: 
              addModal.value.selectedProducts.length || (addModal.value.custom.name && addModal.value.custom.price)
                ? 'primary'
                : 'inactive'
            ,
            disabled: 
              !canUpdateOrders.value || !(addModal.value.selectedProducts.length || (addModal.value.custom.name && addModal.value.custom.price))
            ,
            onClick: saveAddModal
          }, {
            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
              _createTextVNode(" Save ", -1)
            ]))]),
            _: 1
          }, 8, ["type", "disabled"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      (bottle.value)
        ? (_openBlock(), _createBlock(_component_NewReportModal, {
            key: 0,
            "is-open": reportsModal.value,
            bottle: bottle.value,
            onCloseModal: _cache[11] || (_cache[11] = $event => (reportsModal.value = false))
          }, null, 8, ["is-open", "bottle"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (bottle.value?.attributes?.reseller_id)
              ? (_openBlock(), _createBlock(ResellerBanner, {
                  key: 0,
                  "reseller-id": bottle.value.attributes.reseller_id,
                  message: "This order was placed by reseller",
                  class: "max-w-[1040px]"
                }, null, 8, ["reseller-id"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_23, [
              _cache[55] || (_cache[55] = _createElementVNode("h3", {
                "data-overview-heading": "",
                class: "mb-3 text-base font-medium text-gray-900"
              }, "Cart", -1)),
              _createElementVNode("div", {
                class: _normalizeClass([CARD, "lg:flex w-full lg:space-x-12"])
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "py-3"
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_router_link, {
                            to: '/store/products/' + product(item)?.id,
                            class: _normalizeClass(["flex-shrink-0", !product(item)?.attributes.is_active && 'pointer-events-none'])
                          }, {
                            default: _withCtx(() => [
                              (image(product(item)))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: image(product(item)),
                                    class: "h-12 w-12 rounded-md object-cover object-center"
                                  }, null, 8, _hoisted_27))
                                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, _toDisplayString(item?.attributes.quantity), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_router_link, {
                                    to: '/store/products/' + product(item)?.id,
                                    class: _normalizeClass([!product(item)?.attributes.is_active && 'pointer-events-none', "mb-2 text-base tracking-tight font-semibold text-gray-700 hover:text-gray-800 hover:underline"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(product(item)?.attributes.product_name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "class"]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("select", {
                                      class: "w-20 rounded-md border border-gray-300 py-1.5 text-left text-base font-medium leading-5 text-gray-700 shadow-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 sm:text-sm",
                                      disabled: !canUpdateOrders.value,
                                      onChange: $event => (setCartQuantity(item, $event.target.value))
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: 201 }, (_, x) => x), (i) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          selected: item.attributes.quantity == i
                                        }, _toDisplayString(i === 0 ? 'Remove' : i), 9, _hoisted_36))
                                      }), 256))
                                    ], 40, _hoisted_35),
                                    _createElementVNode("div", _hoisted_37, [
                                      _cache[35] || (_cache[35] = _createElementVNode("div", null, "@", -1)),
                                      _createElementVNode("div", null, _toDisplayString(item?.attributes?.net_price_plus_net_variants_price?.format), 1)
                                    ])
                                  ])
                                ]),
                                (variants(product(item)).length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants(product(item)), (variant) => {
                                        return (_openBlock(), _createBlock(_component_VariantRow, {
                                          key: variant.id,
                                          variant: variant,
                                          class: "block",
                                          item: item,
                                          open: openVariantTray.value == variant.id,
                                          onClick: 
                                  () => {
                                    if (openVariantTray.value !== variant.id) openVariantTray.value = variant.id
                                    else openVariantTray.value = null
                                  }
                                ,
                                          onSetOption: setOption,
                                          onSetQuantity: setVariantQuantity
                                        }, null, 8, ["variant", "item", "open", "onClick"]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (selectedSlot.value?.attributes.allow_day_splits)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(_component_SelectInput, {
                                        name: "Arrival day",
                                        options: 
                                  selectedSlot.value?.attributes.possible_cart_item_fulfillment_dates.map(x => ({
                                    name: _unref(dateFmt)(_unref(serverDayToDateObject)(x)),
                                    value: x
                                  }))
                                ,
                                        "model-value": 
                                  item.attributes.fulfillment_group_date ??
                                  selectedSlot.value?.attributes.arrives_beginning_estimate_date
                                ,
                                        slim: true,
                                        "onUpdate:modelValue": e => setFulfillment(item, e)
                                      }, null, 8, ["options", "model-value", "onUpdate:modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (!items.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, "No items"))
                    : _createCommentVNode("", true),
                  _cache[38] || (_cache[38] = _createElementVNode("hr", { class: "divide-gray-200 mb-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_SelectInput, {
                        modelValue: autofillOption.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((autofillOption).value = $event)),
                        slim: true,
                        placeholder: "Select type",
                        options: autofillOptions.value.map(x => ({ name: x.attributes.name, value: x })),
                        disabled: !canUpdateOrders.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed')
                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                      _createVNode(_component_NeueButton, {
                        type: autofillOption.value ? 'secondary' : 'inactive',
                        disabled: !canUpdateOrders.value || !autofillOption.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                        onClick: autofill
                      }, {
                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                          _createTextVNode(" Autofill ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["type", "disabled", "class"])
                    ]),
                    _createVNode(_component_NeueButton, {
                      class: _normalizeClass(["ml-4", !canUpdateOrders.value && 'opacity-50 cursor-not-allowed']),
                      type: "primary",
                      disabled: !canUpdateOrders.value,
                      onClick: addProducts
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode(" + Cart items ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[39] || (_cache[39] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Items", -1)),
                      _createElementVNode("dd", _hoisted_46, _toDisplayString(itemCount.value) + " ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[40] || (_cache[40] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Cart total", -1)),
                      _createElementVNode("dd", _hoisted_48, _toDisplayString(checkout.value?.attributes.cart_total_amount?.format) + "  ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[41] || (_cache[41] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Fulfillment", -1)),
                      _createElementVNode("dd", _hoisted_50, _toDisplayString(checkout.value?.attributes.fulfillment_amount?.format) + "  ", 1)
                    ]),
                    (checkout.value?.attributes.discount_codes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _cache[42] || (_cache[42] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Discount codes", -1)),
                          _createElementVNode("dd", _hoisted_52, _toDisplayString(checkout.value?.attributes.discount_codes), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (checkout.value?.attributes.fulfillment_amount_off?.cents)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _cache[43] || (_cache[43] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Fulfillment discount", -1)),
                          _createElementVNode("dd", _hoisted_54, " (" + _toDisplayString(checkout.value?.attributes.fulfillment_amount_off?.format) + ") ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (checkout.value?.attributes.discount_code_amount?.cents)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _cache[44] || (_cache[44] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Discount amount", -1)),
                          _createElementVNode("dd", _hoisted_56, " (" + _toDisplayString(checkout.value?.attributes.discount_code_amount?.format) + ") ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_57, [
                      _cache[45] || (_cache[45] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Subtotal", -1)),
                      _createElementVNode("dd", _hoisted_58, _toDisplayString(checkout.value?.attributes.bottle_subtotal?.format) + "  ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[46] || (_cache[46] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-700" }, "Tips", -1)),
                      _createElementVNode("dd", _hoisted_60, _toDisplayString(checkout.value?.attributes.tip_amount?.format) + "  ", 1)
                    ]),
                    _createElementVNode("div", {
                      class: "grid grid-cols-3 cursor-pointer",
                      onClick: _cache[13] || (_cache[13] = $event => (taxesExpanded.value = !taxesExpanded.value))
                    }, [
                      _createElementVNode("dt", _hoisted_61, [
                        (taxesExpanded.value)
                          ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                              key: 0,
                              class: "h-4 w-4 -ml-5 mr-1"
                            }))
                          : (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                              key: 1,
                              class: "h-4 w-4 -ml-5 mr-1"
                            })),
                        _cache[47] || (_cache[47] = _createTextVNode(" Taxes + fees ", -1))
                      ]),
                      _createElementVNode("dd", _hoisted_62, _toDisplayString(checkout.value?.attributes.taxes_and_fees?.format) + "  ", 1),
                      (taxesExpanded.value)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(checkout.value?.attributes.taxes_and_fees_breakdown, (line) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createElementVNode("dt", _hoisted_64, _toDisplayString(line.description), 1),
                              _createElementVNode("dd", _hoisted_65, _toDisplayString(line?.amount?.format) + " ", 1)
                            ]))
                          }), 256))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _cache[48] || (_cache[48] = _createElementVNode("dt", { class: "text-sm text-gray-700 font-bold" }, "Total", -1)),
                      _createElementVNode("dd", _hoisted_67, _toDisplayString(checkout.value?.attributes.bottle_total?.format) + "  ", 1)
                    ]),
                    (
                      checkout.value?.attributes.account_credit_amount?.cents &&
                      checkout.value?.attributes.payment_status !== 'paid'
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_68, [
                            _cache[49] || (_cache[49] = _createElementVNode("dt", { class: "text-xs font-medium col-span-2 text-gray-500" }, "Amount covered by account credit", -1)),
                            _createElementVNode("dd", _hoisted_69, _toDisplayString(checkout.value?.attributes.account_credit_amount?.format) + "  ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _cache[50] || (_cache[50] = _createElementVNode("dt", { class: "text-xs font-medium col-span-2 text-gray-500" }, "Amount remaining to charge", -1)),
                            _createElementVNode("dd", _hoisted_71, _toDisplayString(checkout.value?.attributes.chargeable_amount?.format) + "  ", 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (bottle.value?.attributes.actions.recharge && canUpdateOrders.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("dt", _hoisted_73, [
                          _cache[51] || (_cache[51] = _createTextVNode(" Charge difference ", -1)),
                          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_74, [
                            _createVNode(_unref(InformationCircleIcon), { class: "inline-block w-4 h-4" })
                          ])), [
                            [_directive_tippy, {
                        content:
                          'The order was modified after payment. This will charge the customer for the updated total and refund the previous charge.',
                        maxWidth: 250,
                        placement: 'right'
                      }]
                          ])
                        ]),
                        _createElementVNode("dd", _hoisted_75, [
                          _createElementVNode("span", _hoisted_76, [
                            (rechargeError.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(rechargeError.value), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_78, [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              disabled: recharging.value,
                              onClick: rechargeOrder
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(BanknotesIcon), {
                                  class: "-ml-1 mr-2 h-5 w-5",
                                  "aria-hidden": "true"
                                }),
                                _createTextVNode(" " + _toDisplayString(recharging.value ? 'Charging...' : bottle.value?.attributes.actions.recharge_amount?.format), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (bottle.value?.attributes.payment_status !== 'paid')
                    ? (_openBlock(), _createBlock(DiscountCodeInput, {
                        key: 1,
                        ref_key: "discountInput",
                        ref: discountInput,
                        "applied-codes": appliedDiscountCodes.value,
                        onApply: applyDiscountCode,
                        onRemove: removeDiscountCode
                      }, null, 8, ["applied-codes"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_79, [
                    _cache[52] || (_cache[52] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Membership tier", -1)),
                    (bottle.value?.attributes.payment_status === 'paid')
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_80, [
                          (canUpdateMembershipTiers.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/store/membership-tiers/${tier.value?.id}`,
                                class: "cursor-pointer text-blue-600 hover:text-blue-900"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tier.value?.attributes.tier_name), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(tier.value?.attributes.tier_name), 1))
                        ]))
                      : (_openBlock(), _createBlock(_component_SelectInput, {
                          key: 1,
                          class: "w-64",
                          options: tiers.value?.map(x => ({ name: x.attributes.tier_name, value: x.id })),
                          "model-value": tier.value?.id,
                          "onUpdate:modelValue": setTier
                        }, null, 8, ["options", "model-value"]))
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _cache[53] || (_cache[53] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Store", -1)),
                    _createElementVNode("dd", _hoisted_83, [
                      (canUpdateStores.value)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/store/stores/${store.value?.id}`,
                            class: "cursor-pointer text-blue-600 hover:text-blue-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(store.value?.attributes.store_name), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(store.value?.attributes.store_name), 1))
                    ])
                  ]),
                  (drop.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _cache[54] || (_cache[54] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Drop", -1)),
                        _createElementVNode("dd", _hoisted_86, [
                          _createVNode(_component_router_link, {
                            to: `/store/drops/${drop.value?.id}`,
                            class: "cursor-pointer text-blue-600 hover:text-blue-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(drop.value?.attributes.description), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 512), [
              [_vShow, _unref(activeTab) === 'overview']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_87, [
              _cache[81] || (_cache[81] = _createElementVNode("h3", {
                "data-overview-heading": "",
                class: "mb-3 text-base font-medium text-gray-900"
              }, "Fulfillment", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(CARD)
              }, [
                (!selectingSlot.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _cache[57] || (_cache[57] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Fulfillment method", -1)),
                        _createElementVNode("dd", _hoisted_90, [
                          _createElementVNode("span", _hoisted_91, [
                            (slotMethod(selectedSlot.value))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(slotMethod(selectedSlot.value).attributes.name), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_93, "No method selected"))
                          ]),
                          _createElementVNode("span", _hoisted_94, [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              disabled: !canUpdateOrders.value,
                              class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                              onClick: _cache[14] || (_cache[14] = $event => (selectingSlot.value = true))
                            }, {
                              default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                _createTextVNode(" Change ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _cache[59] || (_cache[59] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Fulfillment slot", -1)),
                        _createElementVNode("dd", _hoisted_96, [
                          _createElementVNode("span", _hoisted_97, [
                            (selectedSlot.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(slotArrives(selectedSlot.value)), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_99, "No slot selected"))
                          ]),
                          _createElementVNode("span", _hoisted_100, [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              disabled: !canUpdateOrders.value,
                              class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                              onClick: _cache[15] || (_cache[15] = $event => (selectingSlot.value = true))
                            }, {
                              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                _createTextVNode(" Change ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ])
                        ])
                      ]),
                      (uberDelivery.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                            _cache[64] || (_cache[64] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Uber Direct", -1)),
                            _createElementVNode("dd", _hoisted_102, [
                              (uberDeliveryState.value === 'cancelled_by_you')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Cancelled by you"))
                                : (uberDeliveryState.value === 'cancelled')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[60] || (_cache[60] = _createElementVNode("div", null, "Cancelled", -1)),
                                      (uberDelivery.value.last_error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(uberDelivery.value.last_error), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (uberDeliveryState.value === 'failed')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _cache[61] || (_cache[61] = _createElementVNode("div", null, "Booking failed", -1)),
                                        (uberDelivery.value.last_error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(uberDelivery.value.last_error), 1))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createElementVNode("div", _hoisted_106, _toDisplayString(uberDelivery.value.status.replace(/_/g, ' ')), 1),
                                        (uberDelivery.value.courier_name)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_107, "Courier: " + _toDisplayString(uberDelivery.value.courier_name), 1))
                                          : _createCommentVNode("", true),
                                        (uberDelivery.value.dropoff_eta)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, " ETA: " + _toDisplayString(new Date(uberDelivery.value.dropoff_eta).toLocaleString()), 1))
                                          : _createCommentVNode("", true),
                                        (uberDelivery.value.tracking_url)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 2,
                                              href: uberDelivery.value.tracking_url,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                              class: "text-blue-600 underline"
                                            }, " Track delivery ", 8, _hoisted_109))
                                          : _createCommentVNode("", true)
                                      ], 64)),
                              (uberDelivery.value.fee_charged_at)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_110, " Delivery fee charged to customer: " + _toDisplayString(formatCentsAsDollars(uberDelivery.value.fee_charge_cents)), 1))
                                : (uberDelivery.value.fee_charge_error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, " Delivery fee could not be charged: " + _toDisplayString(uberDelivery.value.fee_charge_error), 1))
                                  : (uberDelivery.value.fee_collected?.cents === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, " Delivery fee not collected on this order "))
                                    : _createCommentVNode("", true),
                              (uberActionError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(uberActionError.value), 1))
                                : _createCommentVNode("", true),
                              (uberDeliveryState.value !== 'active' && canUpdateOrders.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                    _createVNode(_component_NeueButton, {
                                      type: "primary",
                                      loading: bookingCourier.value,
                                      onClick: bookCourier
                                    }, {
                                      default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                        _createTextVNode(" Book courier now ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]))
                                : _createCommentVNode("", true),
                              (uberDeliveryState.value === 'active' && uberDelivery.value.cancellable && canUpdateOrders.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _createVNode(_component_NeueButton, {
                                      type: "secondary",
                                      loading: cancellingCourier.value,
                                      onClick: cancelCourier
                                    }, {
                                      default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                        _createTextVNode(" Cancel courier ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (selectingSlot.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("h2", {
                            class: "flex-auto text-sm font-semibold text-gray-900 cursor-pointer",
                            onClick: _cache[16] || (_cache[16] = $event => {;(selectedDay.value = new Date()), getSlots()})
                          }, _toDisplayString(_unref(monthFormat)(selectedDay.value)), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                            onClick: _cache[17] || (_cache[17] = $event => {;(selectedDay.value = plusMonths(selectedDay.value, -1)), getSlots()})
                          }, [
                            _cache[65] || (_cache[65] = _createElementVNode("span", { class: "sr-only" }, "Previous month", -1)),
                            _createVNode(_unref(ChevronLeftIcon), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                            onClick: _cache[18] || (_cache[18] = $event => {;(selectedDay.value = plusMonths(selectedDay.value, 1)), getSlots()})
                          }, [
                            _cache[66] || (_cache[66] = _createElementVNode("span", { class: "sr-only" }, "Next month", -1)),
                            _createVNode(_unref(ChevronRightIcon), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "mt-10 grid grid-cols-7 text-center text-xs leading-6 text-gray-500" }, [
                          _createElementVNode("div", null, "S"),
                          _createElementVNode("div", null, "M"),
                          _createElementVNode("div", null, "T"),
                          _createElementVNode("div", null, "W"),
                          _createElementVNode("div", null, "T"),
                          _createElementVNode("div", null, "F"),
                          _createElementVNode("div", null, "S")
                        ], -1)),
                        _createElementVNode("div", _hoisted_119, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: day,
                              class: _normalizeClass(["py-2", i > 6 && 'border-t border-gray-200'])
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["mx-auto flex h-8 w-8 items-center justify-center rounded-full", [
                          isSelectedDay(day) && 'text-white',
                          !isSelectedDay(day) && isCurrentDay(day) && 'text-indigo-600',
                          !isSelectedDay(day) && !isCurrentDay(day) && isSelectedMonth(day) && 'text-gray-900',
                          !isSelectedDay(day) && !isCurrentDay(day) && !isSelectedMonth(day) && 'text-gray-400',
                          isSelectedDay(day) && isCurrentDay(day) && 'bg-indigo-600',
                          isSelectedDay(day) && !isCurrentDay(day) && 'bg-gray-900',
                          !isSelectedDay(day) && 'hover:bg-gray-200',
                          (isSelectedDay(day) || isCurrentDay(day)) && 'font-semibold',
                          slots(day).length && 'border border-gray-500',
                          slots(day).some(x => x.id === selectedSlot.value?.id) && 'border-2 border-green-500'
                        ]]),
                                onClick: $event => (selectedDay.value = day)
                              }, _toDisplayString(_unref(dayFormat)(day)), 11, _hoisted_120)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_121, [
                        _createElementVNode("h2", _hoisted_122, " Fulfillment slots for " + _toDisplayString(_unref(monthDayFormat)(selectedDay.value)), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mt-4 flex flex-col gap-y-4", quotingCourier.value && 'opacity-50 pointer-events-none'])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slots(selectedDay.value), (slot) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "relative flex items-center cursor-pointer",
                              onClick: $event => (setSlot(slot))
                            }, [
                              _createElementVNode("input", {
                                type: "radio",
                                checked: slot.id === selectedSlot.value?.id,
                                class: "mr-4 text-green-500 cursor-pointer"
                              }, null, 8, _hoisted_124),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_125, _toDisplayString(slotMethod(slot)?.attributes?.name), 1),
                                _createElementVNode("div", _hoisted_126, "Arrives " + _toDisplayString(slotArrives(slot)), 1)
                              ])
                            ], 8, _hoisted_123))
                          }), 256)),
                          (!slots(selectedDay.value).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_127, "No slots for this day"))
                            : _createCommentVNode("", true),
                          (quotingCourier.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, "Getting courier quote..."))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_129, [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              disabled: !canUpdateOrders.value,
                              onClick: _cache[19] || (_cache[19] = $event => (selectingSlot.value = false))
                            }, {
                              default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                _createTextVNode(" Done ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (selectedMethod.value?.attributes.type !== 'PickupFulfillmentMethod')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _cache[80] || (_cache[80] = _createElementVNode("hr", { class: "divide-gray-200 my-3" }, null, -1)),
                      _createElementVNode("div", _hoisted_131, [
                        _cache[79] || (_cache[79] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Address", -1)),
                        _createElementVNode("dd", _hoisted_132, [
                          (selectingAddress.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                (!editingAddress.value || !draftAddress.value.id)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(addresses.value, (address) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass([[
                          address.id === selectedAddress.value?.id && 'border-green-500 ring-2 ring-green-500',
                          !canUpdateOrders.value && 'opacity-60 cursor-not-allowed'
                        ], "rounded-lg border bg-white py-2 px-3 shadow-sm cursor-pointer relative flex"]),
                                        onClick: $event => (canUpdateOrders.value && setAddress(address))
                                      }, [
                                        _createElementVNode("div", _hoisted_135, [
                                          _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("div", null, _toDisplayString(address.attributes.address1), 1),
                                            (address.attributes.address2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString(address.attributes.address2), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", null, _toDisplayString(address.attributes.city) + _toDisplayString(address.attributes.city && address.attributes.state ? ',' : '') + " " + _toDisplayString(address.attributes.state) + " " + _toDisplayString(address.attributes.zip), 1),
                                            (address.attributes.notes)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(address.attributes.notes), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_139, [
                                          (canUpdateOrders.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "h-6 w-6 flex items-center justify-center border border-gray-400 hover:border-brand-500 hover:bg-gray-50 transition-all duration-100 rounded-full",
                                                onClick: _withModifiers($event => (editAddress(address)), ["stop"])
                                              }, [
                                                _createVNode(_unref(PencilIcon), { class: "h-3.5 w-3.5" })
                                              ], 8, _hoisted_140))
                                            : _createCommentVNode("", true),
                                          (canUpdateOrders.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "h-6 w-6 flex items-center justify-center border border-gray-400 hover:border-brand-500 hover:bg-gray-50 transition-all duration-100 rounded-full",
                                                onClick: _withModifiers($event => (deleteAddress(address)), ["stop"])
                                              }, [
                                                _createVNode(_unref(XMarkIcon), { class: "h-4 w-4" })
                                              ], 8, _hoisted_141))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, _hoisted_134))
                                    }), 256))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_142, [
                                  _createElementVNode("div", null, [
                                    (!editingAddress.value)
                                      ? (_openBlock(), _createBlock(_component_NeueButton, {
                                          key: 0,
                                          type: "secondary",
                                          disabled: !canUpdateOrders.value,
                                          onClick: addAddress
                                        }, {
                                          default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                            _createTextVNode(" + Address ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"]))
                                      : _createCommentVNode("", true),
                                    (editingAddress.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                          _createElementVNode("div", _hoisted_144, [
                                            _cache[70] || (_cache[70] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Address line 1", -1)),
                                            _createVNode(_component_DescriptionListInput, {
                                              modelValue: draftAddress.value.address1,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((draftAddress.value.address1) = $event)),
                                              class: "mt-1 sm:col-span-2 sm:mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_145, [
                                            _cache[71] || (_cache[71] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Address line 2", -1)),
                                            _createVNode(_component_DescriptionListInput, {
                                              modelValue: draftAddress.value.address2,
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((draftAddress.value.address2) = $event)),
                                              class: "mt-1 sm:col-span-2 sm:mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_146, [
                                            _cache[72] || (_cache[72] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "City", -1)),
                                            _createVNode(_component_DescriptionListInput, {
                                              modelValue: draftAddress.value.city,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((draftAddress.value.city) = $event)),
                                              class: "mt-1 sm:col-span-2 sm:mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_147, [
                                            _cache[73] || (_cache[73] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "State", -1)),
                                            _createElementVNode("div", _hoisted_148, [
                                              _createVNode(_component_SelectInput, {
                                                modelValue: draftAddress.value.state,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((draftAddress.value.state) = $event)),
                                                options: allStates.value
                                              }, null, 8, ["modelValue", "options"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_149, [
                                            _cache[74] || (_cache[74] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "ZIP code", -1)),
                                            _createVNode(_component_DescriptionListInput, {
                                              modelValue: draftAddress.value.zip,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((draftAddress.value.zip) = $event)),
                                              class: "mt-1 sm:col-span-2 sm:mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_150, [
                                            _cache[75] || (_cache[75] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Notes", -1)),
                                            _createVNode(_component_DescriptionListInput, {
                                              modelValue: draftAddress.value.notes,
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((draftAddress.value.notes) = $event)),
                                              class: "mt-1 sm:col-span-2 sm:mt-0"
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (editingAddress.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                        _createVNode(_component_NeueButton, {
                                          type: "secondary",
                                          disabled: !canUpdateOrders.value,
                                          onClick: _cache[26] || (_cache[26] = $event => (editingAddress.value = false))
                                        }, {
                                          default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                            _createTextVNode(" Cancel ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createVNode(_component_NeueButton, {
                                          type: "primary",
                                          disabled: !canUpdateOrders.value,
                                          onClick: saveAddress
                                        }, {
                                          default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                            _createTextVNode("Save", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                _createElementVNode("span", _hoisted_153, [
                                  (selectedAddress.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                        _createElementVNode("div", null, _toDisplayString(selectedAddress.value.attributes.address1), 1),
                                        (selectedAddress.value.attributes.address2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_155, _toDisplayString(selectedAddress.value.attributes.address2), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", null, _toDisplayString(selectedAddress.value.attributes.city) + _toDisplayString(selectedAddress.value.attributes.city && selectedAddress.value.attributes.state ? ',' : '') + " " + _toDisplayString(selectedAddress.value.attributes.state) + " " + _toDisplayString(selectedAddress.value.attributes.zip), 1),
                                        (selectedAddress.value.attributes.notes)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(selectedAddress.value.attributes.notes), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_157, "No address selected"))
                                ]),
                                _createElementVNode("span", _hoisted_158, [
                                  _createVNode(_component_NeueButton, {
                                    type: "secondary",
                                    disabled: !canUpdateOrders.value,
                                    class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                                    onClick: _cache[27] || (_cache[27] = $event => (selectingAddress.value = true))
                                  }, {
                                    default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                      _createTextVNode(" Change ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled", "class"])
                                ])
                              ]))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _unref(activeTab) === 'overview']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_159, [
              _cache[98] || (_cache[98] = _createElementVNode("h3", {
                "data-overview-heading": "",
                class: "mb-3 text-base font-medium text-gray-900"
              }, "Payment", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(CARD)
              }, [
                _createElementVNode("div", _hoisted_160, [
                  _cache[82] || (_cache[82] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Add tax to order", -1)),
                  _createElementVNode("dd", _hoisted_161, [
                    _createElementVNode("span", _hoisted_162, _toDisplayString(!selectedSlot.value ? 'Select a fulfillment slot to change' : ''), 1),
                    _createElementVNode("span", _hoisted_163, [
                      _createVNode(_component_SelectInput, {
                        class: _normalizeClass(["w-64", (!selectedSlot.value || !canUpdateOrders.value) && 'opacity-50 cursor-not-allowed']),
                        slim: true,
                        options: [
                        { name: 'Yes', value: true },
                        { name: 'No', value: false }
                      ],
                        "model-value": bottle.value?.attributes.calculate_tax_on_custom_invoice,
                        disabled: !selectedSlot.value || !canUpdateOrders.value,
                        "onUpdate:modelValue": setTax
                      }, null, 8, ["class", "model-value", "disabled"])
                    ])
                  ])
                ]),
                (payment.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                      (payment.value?.attributes.created_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                            _cache[83] || (_cache[83] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Date issued", -1)),
                            _createElementVNode("dd", _hoisted_166, _toDisplayString(_unref(dateTimeFormat)(Date.parse(payment.value?.attributes.created_at))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("dt", _hoisted_168, _toDisplayString(_unref(collectedOutsideStripe)(payment.value) ? 'Amount collected' : 'Amount charged'), 1),
                        _createElementVNode("dd", _hoisted_169, _toDisplayString(payment.value?.attributes.charged_amount?.format), 1)
                      ]),
                      (payment.value?.attributes.account_credit_amount?.cents)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                            _cache[84] || (_cache[84] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Account credit used", -1)),
                            _createElementVNode("dd", _hoisted_171, _toDisplayString(payment.value?.attributes.account_credit_amount?.format), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (payment.value?.attributes.reason !== 'stripe_payment')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                            _cache[85] || (_cache[85] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Reason", -1)),
                            _createElementVNode("dd", _hoisted_173, _toDisplayString(_unref(paymentReasonLabel)(bottle.value?.attributes, payment.value)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (checkout.value?.attributes.refunded_amount?.cents)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                            _cache[86] || (_cache[86] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Amount refunded", -1)),
                            _createElementVNode("dd", _hoisted_175, _toDisplayString(checkout.value?.attributes.refunded_amount?.format), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (paymentMethod.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                            _cache[87] || (_cache[87] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Card info", -1)),
                            _createElementVNode("dd", _hoisted_177, [
                              (paymentMethod.value?.attributes.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_178, _toDisplayString(paymentMethod.value?.attributes.name) + " |", 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" *" + _toDisplayString(paymentMethod.value?.attributes.last4) + " | " + _toDisplayString(paymentMethod.value?.attributes.brand.charAt(0).toUpperCase() + paymentMethod.value?.attributes.brand.slice(1)) + " | " + _toDisplayString(paymentMethod.value?.attributes.exp_month.toString().padStart(2, 0)) + "/" + _toDisplayString(paymentMethod.value?.attributes.exp_year), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_179, "Order is unpaid")),
                (checkout.value?.attributes.stripe_token && bottle.value?.attributes.actions.mark_as_paid && !bottleInvoice.value)
                  ? (_openBlock(), _createBlock(_component_Payment, {
                      key: 2,
                      checkout: checkout.value,
                      "conversation-user-pair": pair.value,
                      "mark-as-paid": bottle.value?.attributes.actions.mark_as_paid && canUpdateOrders.value ? markAsPaid : null
                    }, null, 8, ["checkout", "conversation-user-pair", "mark-as-paid"]))
                  : _createCommentVNode("", true),
                (bottleInvoice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                      _cache[90] || (_cache[90] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Invoice", -1)),
                      _createElementVNode("dd", _hoisted_181, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-1.5 py-0.5 rounded-md text-xs font-semibold", 
                      bottleInvoice.value.attributes.status === 'open'
                        ? 'bg-amber-100 text-amber-800'
                        : 'bg-green-100 text-green-800'
                    ])
                        }, _toDisplayString(invoiceStatusLabel.value), 3),
                        _createElementVNode("span", null, _toDisplayString(bottleInvoice.value.attributes.amount_due?.format), 1),
                        (invoiceDueDate.value && bottleInvoice.value.attributes.status === 'open')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_182, " due " + _toDisplayString(invoiceDueDate.value), 1))
                          : _createCommentVNode("", true),
                        (bottleInvoice.value.attributes.hosted_invoice_url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: bottleInvoice.value.attributes.hosted_invoice_url,
                              target: "_blank",
                              rel: "noopener",
                              class: "underline"
                            }, " View invoice ", 8, _hoisted_183))
                          : _createCommentVNode("", true),
                        (bottleInvoice.value.attributes.status === 'open' && canUpdateOrders.value)
                          ? (_openBlock(), _createBlock(_component_NeueButton, {
                              key: 2,
                              type: "secondary",
                              onClick: markAsPaid
                            }, {
                              default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                _createTextVNode(" Mark as paid ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (bottleInvoice.value.attributes.status === 'open' && canUpdateOrders.value)
                          ? (_openBlock(), _createBlock(_component_NeueButton, {
                              key: 3,
                              type: "secondary",
                              loading: resendingInvoice.value,
                              onClick: resendInvoice
                            }, {
                              default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                                _createTextVNode(" Resend invoice ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_184, [
                  _cache[93] || (_cache[93] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Tip", -1)),
                  _createElementVNode("dd", _hoisted_185, [
                    (!selectingTip.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_186, [
                            (tip.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                  (tip.value.attributes.tip_percentage)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_188, _toDisplayString(tip.value.attributes.tip_percentage) + "% (" + _toDisplayString(tip.value?.attributes?.tip_amount?.format) + ") ", 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(tip.value?.attributes?.tip_amount?.format), 1))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_190, "No tip"))
                          ]),
                          _createElementVNode("span", _hoisted_191, [
                            _createVNode(_component_NeueButton, {
                              type: "secondary",
                              disabled: !canUpdateOrders.value,
                              class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                              onClick: _cache[28] || (_cache[28] = $event => (selectingTip.value = true))
                            }, {
                              default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                _createTextVNode(" Change ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_192, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(possibleTips.value, (possibleTip) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["rounded-lg border border-gray-300 bg-white py-2 px-3 shadow-sm cursor-pointer", !canUpdateOrders.value && 'opacity-60 cursor-not-allowed']),
                              onClick: $event => (canUpdateOrders.value && setTip(possibleTip))
                            }, [
                              (possibleTip.attributes.tip_percentage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_194, _toDisplayString(possibleTip.attributes.tip_percentage) + "% (" + _toDisplayString(possibleTip?.attributes?.tip_amount?.format) + ") ", 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(possibleTip?.attributes?.tip_amount?.format), 1))
                            ], 10, _hoisted_193))
                          }), 256)),
                          _createElementVNode("div", _hoisted_196, [
                            _createVNode(_component_InputField, {
                              modelValue: customTipAmount.value,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => ((customTipAmount).value = $event)),
                              prefix: "$",
                              restrict: "monetary",
                              class: "w-32"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_NeueButton, {
                              type: customTipAmount.value ? 'secondary' : 'inactive',
                              disabled: !canUpdateOrders.value || !customTipAmount.value,
                              onClick: setCustomTip
                            }, {
                              default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                _createTextVNode(" Save ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["type", "disabled"])
                          ])
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_197, [
                  (bottle.value?.attributes.actions.mark_as_unpaid)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 0,
                        type: "secondary",
                        disabled: !canUpdateOrders.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                        onClick: markAsUnpaid
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BanknotesIcon), {
                            class: "-ml-1 mr-2 h-5 w-5",
                            "aria-hidden": "true"
                          }),
                          _cache[94] || (_cache[94] = _createTextVNode(" Mark as unpaid ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"]))
                    : _createCommentVNode("", true),
                  (bottle.value?.attributes.actions.cancel_order)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 1,
                        type: "secondary",
                        disabled: !canUpdateOrders.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                        onClick: cancelOrder
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XMarkIcon), {
                            class: "-ml-1 mr-2 h-5 w-5",
                            "aria-hidden": "true"
                          }),
                          _cache[95] || (_cache[95] = _createTextVNode(" Cancel ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"]))
                    : _createCommentVNode("", true),
                  (bottle.value?.attributes.actions.un_cancel_order)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 2,
                        type: "secondary",
                        disabled: !canUpdateOrders.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                        onClick: uncancelOrder
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CheckIcon), {
                            class: "-ml-1 mr-2 h-5 w-5",
                            "aria-hidden": "true"
                          }),
                          _cache[96] || (_cache[96] = _createTextVNode(" Uncancel ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"]))
                    : _createCommentVNode("", true),
                  (bottle.value?.attributes.actions.refund)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 3,
                        type: "secondary",
                        disabled: !canUpdateOrders.value,
                        class: _normalizeClass(!canUpdateOrders.value && 'opacity-50 cursor-not-allowed'),
                        onClick: _cache[30] || (_cache[30] = $event => (refundModal.value = true))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ReceiptRefundIcon), {
                            class: "-ml-1 mr-2 h-5 w-5",
                            "aria-hidden": "true"
                          }),
                          _cache[97] || (_cache[97] = _createTextVNode(" Refund ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 512), [
              [_vShow, _unref(activeTab) === 'overview']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_198, [
              _createElementVNode("div", {
                class: _normalizeClass(CARD)
              }, [
                _createVNode(_component_NeueLoading, { loading: activityLoading.value }, {
                  default: _withCtx(() => [
                    (activityLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_200, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (activity, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: activity.id
                        }, [
                          _createElementVNode("div", _hoisted_201, [
                            (i !== activities.value.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_202))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_203, [
                              _createElementVNode("div", _hoisted_204, [
                                (activity.type === 'cart')
                                  ? (_openBlock(), _createBlock(_unref(ShoppingBagIcon), {
                                      key: 0,
                                      class: "h-5 w-5 text-gray-500"
                                    }))
                                  : (_openBlock(), _createBlock(_resolveDynamicComponent(activityIcon(activity)), {
                                      key: 1,
                                      class: _normalizeClass(["h-5 w-5", activityColor(activity)])
                                    }, null, 8, ["class"]))
                              ]),
                              _createElementVNode("div", _hoisted_205, [
                                (activity.type === 'cart')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      ref_for: true,
                                      ref: el => (cartRefs.value[activity.id] = el),
                                      class: _normalizeClass(["text-sm text-gray-500 flex flex-wrap items-start", activity.relationships?.cart_items?.data?.length && 'cursor-pointer']),
                                      onClick: $event => (activity.relationships?.cart_items?.data?.length && toggleCart(activity))
                                    }, [
                                      _createElementVNode("div", null, [
                                        _cache[99] || (_cache[99] = _createTextVNode(" Cart edited ", -1)),
                                        _createElementVNode("span", _hoisted_207, _toDisplayString({
                                    MerchantApp: 'by the customer. ',
                                    DashboardApp: 'from the dashboard. ',
                                    Autofill: 'by autofill. '
                                  }[activity.attributes.place_created] ?? 'by the system. '), 1),
                                        _createElementVNode("span", _hoisted_208, _toDisplayString(activity.attributes.quantity), 1),
                                        _cache[100] || (_cache[100] = _createTextVNode(" items, ", -1)),
                                        _createElementVNode("span", _hoisted_209, _toDisplayString(activity?.attributes?.total_price?.format), 1),
                                        _cache[101] || (_cache[101] = _createElementVNode("span", null, ".", -1))
                                      ]),
                                      (activity.relationships?.cart_items?.data?.length)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (openCarts.value.has(activity.id))
                                              ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                                                  key: 0,
                                                  class: "inline ml-1 h-5 w-5"
                                                }))
                                              : (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                                                  key: 1,
                                                  class: "inline ml-1 h-5 w-5"
                                                })),
                                            (openCarts.value.has(activity.id))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapRelationships)(activity.relationships?.cart_items?.data ?? []), (item) => {
                                                    return (_openBlock(), _createElementBlock("div", null, [
                                                      _createTextVNode(_toDisplayString(item.attributes.quantity) + "× " + _toDisplayString(product(item)?.attributes.product_name) + " ", 1),
                                                      (itemVariants(item))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_211, "(" + _toDisplayString(itemVariants(item)) + ")", 1))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 256))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_206))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                      _createTextVNode(_toDisplayString(activity.attributes.description) + " ", 1),
                                      (activity.attributes.secondary_text)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_213, _toDisplayString(activity.attributes.secondary_text), 1))
                                        : _createCommentVNode("", true)
                                    ])),
                                _createElementVNode("div", _hoisted_214, [
                                  (activity.type === 'cart')
                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                        key: 0,
                                        type: "secondary",
                                        class: _normalizeClass(["mr-2", !canUpdateOrders.value && 'opacity-50 cursor-not-allowed']),
                                        disabled: !canUpdateOrders.value,
                                        onClick: $event => (rollback(activity))
                                      }, {
                                        default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                                          _createTextVNode(" Rollback ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["disabled", "class", "onClick"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_215, _toDisplayString(_unref(activityFormat)(new Date(activity.attributes.created_at))), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 512), [
              [_vShow, _unref(activeTab) === 'activity']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_216, [
              (reports.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: [
                        { width: 'minmax(120px, 1fr)' },
                        { width: 'minmax(150px, 2fr)' },
                        { width: 'minmax(120px, 1.5fr)' },
                        { width: '160px' }
                      ],
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[104] || (_cache[104] = _createElementVNode("div", null, "Time Created", -1)),
                                _cache[105] || (_cache[105] = _createElementVNode("div", null, "Report Description", -1)),
                                _cache[106] || (_cache[106] = _createElementVNode("div", null, "Emailed To", -1)),
                                _createElementVNode("div", _hoisted_218, [
                                  _createVNode(_component_NeueButton, {
                                    type: "primary",
                                    disabled: !canCreateReports.value,
                                    class: _normalizeClass(!canCreateReports.value && 'opacity-50 cursor-not-allowed'),
                                    onClick: _cache[31] || (_cache[31] = $event => (reportsModal.value = true))
                                  }, {
                                    default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                                      _createTextVNode(" + Report ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled", "class"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: report.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, {
                                columns: [
                      { width: 'minmax(120px, 1fr)' },
                      { width: 'minmax(150px, 2fr)' },
                      { width: 'minmax(120px, 1.5fr)' },
                      { width: '160px' }
                    ],
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_219, _toDisplayString(_unref(dateTimeFormat)(new Date(report.attributes.created_at))), 1),
                                  _createElementVNode("div", _hoisted_220, _toDisplayString(report.attributes.display_name), 1),
                                  _createElementVNode("div", null, [
                                    (report.attributes.email)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_221, _toDisplayString(report.attributes.email), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_222, "No email"))
                                  ]),
                                  _createElementVNode("div", _hoisted_223, [
                                    (report.attributes.is_expired)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_224, "Expired"))
                                      : (report.attributes.link_to_report)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            href: report.attributes.link_to_report,
                                            class: "flex align-middle",
                                            target: "_blank"
                                          }, [
                                            _cache[107] || (_cache[107] = _createTextVNode(" Download ", -1)),
                                            _createVNode(_unref(ArrowDownTrayIcon), { class: "ml-2 h-5 w-5 inline" })
                                          ], 8, _hoisted_225))
                                        : (_openBlock(), _createBlock(_component_BasicSpinner, { key: 2 }))
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!reports.value?.length)
                ? (_openBlock(), _createBlock(_component_NeueWell, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, { plural: "downloaded reports yet" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NeueButton, {
                            type: "primary",
                            disabled: !canCreateReports.value,
                            class: _normalizeClass(!canCreateReports.value && 'opacity-50 cursor-not-allowed'),
                            onClick: _cache[32] || (_cache[32] = $event => (reportsModal.value = true))
                          }, {
                            default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                              _createTextVNode(" + Report ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled", "class"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _unref(activeTab) === 'reports']
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}